import { useState, useEffect, useRef } from 'react';

import { openModal, closeModal } from '@/services/modalsProvider';
import { MODAL_NAMES } from '@/utils/constants';

/**
 * Хук для управления кнопкой бургера меню.
 * @param {Function} options.onTariffsClick - обработка клика по кнопке "Тарифы".
 * @returns {{
 *   isBurgerOpen: boolean,
 *   toggleBurgerState: Function,
 * }}
 */
export const useBurger = ({ onTariffsClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const modalParams = useRef({
    modalName: MODAL_NAMES.navigation,
    id: MODAL_NAMES.navigation,
    props: {
      closeModal: () => setIsOpen(false),
      onTariffsClick,
    },
  });

  useEffect(() => {
    if (isOpen) {
      openModal(modalParams.current);
    } else {
      closeModal(modalParams.current);
    }
  }, [isOpen]);

  return {
    isBurgerOpen: isOpen,
    toggleBurgerState: () => setIsOpen((prev) => !prev),
  };
};
